export const DEFAULT_DOC_PATH = 'provider=onedrive/drive=user_email';
